import styled from 'styled-components';
import primitives from '@veneer/primitives';
import { Card } from '@veneer/core';

export const Container = styled(Card)`
  && {
    border: solid 1px ${primitives.color.gray3};
    border-radius: ${primitives.layout.cornerRadius4}px;
    min-height: 421px;
    width: 100%;
  }
  &, * {
    box-sizing: border-box;
  }
`;

export const CardHeader = styled.header`
  display: flex;
  align-items: center;
  padding: ${primitives.layout.size6}px;
  border-bottom: 1px solid ${primitives.color.gray3};
`;

export const Title = styled.h2`
  margin-right: auto;
`;

export const StatusLoader = styled.div`
  margin: auto;
  height: 100%;
`;

export const CardBody = styled.div`
  display: flex;
  min-height: 354px;
  overflow-y: hidden;
  flex-direction: column;
  width: 100%;

  && {
    box-sizing: content-box;
  }

  & > *:not(:last-child) {
    padding-bottom: ${primitives.layout.size1}px;
    border-bottom: 1px solid ${primitives.color.gray3};
  }
`;
